var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var BreadcrumbView = require('common/views/BreadcrumbView');

var eventDetailsForm = require('../views/COCEventDetailsView');
var SubmitEditEventDetails = require('../services/SubmitEditEventDetails');

var tmplCOCEditEventDetailsView = require('../templates/COCEditEventDetailsView.hbs');
require('../styles/COCEditEventDetailsView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEditEventDetailsView,

  className: 'coc-edit-event-details-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    eventDetailsContainer: '.event-details-container',
    submit: '.submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    eventDetailsContainer: '@ui.eventDetailsContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var event = this.model.get('event');
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            link: '#coc/event/' + event.id,
            text: event.eventTitle
          },
          {
            text: 'Edit Event Details'
          }
        ]
      })
    );

    var eventDetailsModel = this.model;
    this.eventDetailsForm = new eventDetailsForm({ model: eventDetailsModel });
    this.showChildView('eventDetailsContainer', this.eventDetailsForm);
  },

  validate: function() {
    return this.eventDetailsForm.validate({ type: 'submit' });
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.eventId = this.model.get('eventId');

    return formData;
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var l = Ladda.create(this.ui.submit[0]);
    l.start();
    this.validate()
      .done(function() {
        var formData = self.getFormData();
        SubmitEditEventDetails(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:coc:event', formData.eventId);
          })
          .fail(function() {
            l.stop();
          });
      })
      .fail(function() {
        l.stop();
      });
  }
});
